"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8762],{

/***/ 24903:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14416);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(51469);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(48641);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(47741);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(57026);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(71197);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(18132);
/* harmony import */ var src_icons__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(27120);
/* harmony import */ var src_redux_sell_offer_actions__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(60812);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(38762);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(85893);











var ActionBar = function ActionBar(_ref) {
  var _ref$offersCount = _ref.offersCount,
      offersCount = _ref$offersCount === void 0 ? null : _ref$offersCount;
  var visibleOnMobile = (0,_chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__/* .useBreakpointValue */ .Sx)({
    base: true,
    md: false
  });
  var orders = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)(function (state) {
    return state.sell.orders;
  });
  var offers = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)(function (state) {
    return state.sell.filteredOffers;
  });
  var filterMenuIsOpen = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)(function (state) {
    return state.sell.filterMenuIsOpen;
  });
  var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useDispatch */ .I0)();

  var _useTranslation = (0,react_i18next__WEBPACK_IMPORTED_MODULE_7__/* .useTranslation */ .$)(),
      t = _useTranslation.t;

  var toggleFilterMenuHandler = function toggleFilterMenuHandler() {
    return dispatch((0,src_redux_sell_offer_actions__WEBPACK_IMPORTED_MODULE_3__/* .toggleFilterMenu */ .hg)());
  };

  var changeOrderHandler = function changeOrderHandler(_ref2) {
    var value = _ref2.target.value;
    return dispatch((0,src_redux_sell_offer_actions__WEBPACK_IMPORTED_MODULE_3__/* .toggleOrder */ .YQ)(value));
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.Fragment, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__/* .SimpleGrid */ .MI, {
      columns: {
        base: 1,
        md: 4
      },
      pr: "l",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__/* .Box */ .xu, {
        textAlign: "left",
        display: {
          base: 'none',
          md: 'flex'
        },
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_9__/* .Button */ .zx, {
          onClick: toggleFilterMenuHandler,
          leftIcon: filterMenuIsOpen ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(src_icons__WEBPACK_IMPORTED_MODULE_2__/* .ArrowLeftIcon */ .Y4, {}) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(src_icons__WEBPACK_IMPORTED_MODULE_2__/* .ArrowRightIcon */ .LZ, {}),
          color: "baseDark",
          fontFamily: "Montserrat-Medium",
          variant: "link",
          fontSize: "1rem",
          fontWeight: "normal",
          children: filterMenuIsOpen ? t('sellActionbarContainer:hideFilters') : t('sellActionbarContainer:showFilters')
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__/* .Box */ .xu, {
        textAlign: "left",
        fontFamily: "Montserrat-SemiBold",
        fontSize: "1.375rem",
        pt: "2",
        pl: "3",
        children: t('sellActionbarContainer:nOffersFound', {
          count: offersCount || offers.results
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__/* .Box */ .xu, {
        display: {
          base: 'none',
          md: 'flex'
        }
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__/* .Box */ .xu, {
        textAlign: "right",
        fontFamily: "Montserrat-SemiBold",
        fontSize: "1rem",
        display: {
          base: 'none',
          md: 'block'
        },
        children: [t('sellActionbarContainer:sortBy'), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_10__/* .Select */ .Ph, {
          variant: "flushed",
          display: "inline-block",
          width: "initial",
          ml: 4,
          fontFamily: "Montserrat-Regular",
          onChange: changeOrderHandler,
          children: orders.map(function (sort) {
            return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("option", {
              value: sort.value,
              children: sort.label || sort.name
            }, sort.value);
          })
        })]
      })]
    }), !visibleOnMobile && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_11__/* .Slide */ .Mi, {
      className: "offers-filters-desktop-container",
      in: filterMenuIsOpen,
      direction: "left",
      unmountOnExit: true,
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__/* .Box */ .xu, {
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(___WEBPACK_IMPORTED_MODULE_4__/* .FiltersList */ .x0, {})
      })
    })]
  });
};

/* harmony default export */ __webpack_exports__["default"] = (ActionBar);

/***/ }),

/***/ 2901:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var src_uikit__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(58598);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(48641);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(38762);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);







var MobileActionBar = function MobileActionBar() {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(src_uikit__WEBPACK_IMPORTED_MODULE_1__/* .Sticky */ .Le, {
    h: "14",
    visible: true,
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .Wrap */ .Eq, {
      spacing: "0",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .WrapItem */ .Uc, {
        w: "50%",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(___WEBPACK_IMPORTED_MODULE_2__/* .SortsModal */ .sj, {})
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .WrapItem */ .Uc, {
        w: "50%",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(___WEBPACK_IMPORTED_MODULE_2__/* .FiltersModal */ .FA, {})
      })]
    })
  });
};

/* harmony default export */ __webpack_exports__["default"] = (MobileActionBar);

/***/ }),

/***/ 38762:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ol": function() { return /* reexport */ ActionBar["default"]; },
  "b9": function() { return /* reexport */ SellOffers_AutoPromo; },
  "Do": function() { return /* reexport */ SellOffers_FilterSwitch; },
  "dB": function() { return /* reexport */ SellOffers_FilterTag; },
  "TY": function() { return /* reexport */ SellOffers_FilterTagCheckbox; },
  "Sz": function() { return /* reexport */ SellOffers_FilterTagImage; },
  "x0": function() { return /* reexport */ SellOffers_FiltersList; },
  "Iw": function() { return /* reexport */ SellOffers_FiltersListBox; },
  "nd": function() { return /* reexport */ SellOffers_FiltersListGroup; },
  "mW": function() { return /* reexport */ SellOffers_FiltersListGroups; },
  "jM": function() { return /* reexport */ SellOffers_FiltersListItem; },
  "dj": function() { return /* reexport */ SellOffers_FiltersListItemContent; },
  "h2": function() { return /* reexport */ SellOffers_FiltersListItemNoChildren; },
  "wK": function() { return /* reexport */ SellOffers_FiltersListItemsWrapper; },
  "FA": function() { return /* reexport */ SellOffers_FiltersModal; },
  "Vw": function() { return /* reexport */ SellOffers_Offer; },
  "sj": function() { return /* reexport */ SellOffers_SortsModal; },
  "LQ": function() { return /* reexport */ SellOffers_SuggestedFilters; }
});

// UNUSED EXPORTS: MobileActionBar

// EXTERNAL MODULE: ./src/components/SellOffers/ActionBar.tsx
var ActionBar = __webpack_require__(24903);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/index.esm.js
var index_esm = __webpack_require__(48641);
// EXTERNAL MODULE: ./src/themes/index.tsx + 3 modules
var themes = __webpack_require__(37930);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/icons/dist/index.esm.js
var dist_index_esm = __webpack_require__(3382);
// EXTERNAL MODULE: ./src/uikit/index.tsx + 33 modules
var uikit = __webpack_require__(58598);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/SellOffers/AutoPromo.tsx








var AutoPromo = function AutoPromo(_ref) {
  var item = _ref.item;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(uikit/* CardLink */.YS, {
    href: item.link || '',
    title: item.linkText || 'Scopri di più',
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
      bg: item.layout === 'outline' ? 'baseWhite' : 'primaryGreen.800',
      bgImage: item.image ? "url(".concat(item.image, ")") : '',
      bgPosition: item.image ? '95% 95%' : '',
      bgRepeat: item.image ? 'no-repeat' : '',
      bgSize: item.image ? '20%' : '',
      p: "l",
      h: "370px",
      borderRadius: 10,
      overflow: "hidden",
      borderColor: item.layout === 'outline' ? themes/* theme.colors.borders.grey */.r.colors.borders.grey : 'primaryGreen.800',
      borderWidth: 1,
      boxShadow: themes/* theme.shadows.cards */.r.shadows.cards,
      textAlign: "left",
      color: item.layout === 'outline' ? 'baseDark' : 'baseWhite',
      position: "relative",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Heading */.X6, {
        fontSize: "1.75rem",
        children: item.title
      }), item.text && /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
        marginTop: "s",
        fontFamily: "Montserrat-Medium",
        fontSize: "1.125rem",
        pb: "s",
        children: item.text
      }), item.listItems && /*#__PURE__*/(0,jsx_runtime.jsx)(uikit/* ListWithIcons */.S$, {
        items: item.listItems,
        color: "baseDark"
      }), item.link && item.linkText && /*#__PURE__*/(0,jsx_runtime.jsxs)(index_esm/* Text */.xv, {
        title: item.linkText,
        fontSize: "m",
        color: item.layout === 'outline' ? 'baseDark' : 'baseWhite',
        children: [item.linkText, " ", /*#__PURE__*/(0,jsx_runtime.jsx)(dist_index_esm/* ArrowForwardIcon */.mr, {})]
      })]
    })
  });
};

/* harmony default export */ var SellOffers_AutoPromo = (AutoPromo);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 20 modules
var es = __webpack_require__(14416);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js + 6 modules
var useTranslation = __webpack_require__(18132);
// EXTERNAL MODULE: ./src/redux/sell-offer/actions.ts
var actions = __webpack_require__(60812);
;// CONCATENATED MODULE: ./src/components/SellOffers/FiltersList.tsx











var FiltersList = function FiltersList() {
  var _useTranslation = (0,useTranslation/* useTranslation */.$)(),
      t = _useTranslation.t;

  var suggestedFilters = (0,es/* useSelector */.v9)(function (state) {
    return state.sell.suggestedFilters;
  });
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(SellOffers_FiltersListBox, {
      display: {
        base: 'block',
        md: 'none'
      },
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
        fontFamily: "Montserrat-SemiBold",
        fontWeight: "bold",
        fontSize: themes/* theme.space.s */.r.space.s,
        color: "baseNeutral.700",
        pb: "4",
        children: t('offersListContainer:suggestedFilters')
      }), suggestedFilters.map(function (filterGroup) {
        return filterGroup.items.map(function (item) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)(SellOffers_FilterTag, {
            item: item,
            groupKey: filterGroup.key,
            onClick: function onClick() {
              return (0,actions/* toggleFilter */.cT)(item.value, filterGroup.key);
            }
          }, "suggested-".concat(item.name, "-").concat(item.value));
        });
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(SellOffers_FiltersListGroups, {})]
  });
};

/* harmony default export */ var SellOffers_FiltersList = (FiltersList);
;// CONCATENATED MODULE: ./src/components/SellOffers/FiltersListBox.tsx





var FiltersListBox = function FiltersListBox(_ref) {
  var display = _ref.display,
      children = _ref.children;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
    borderRadius: {
      base: 0,
      md: 10
    },
    bg: "baseWhite",
    p: "l",
    mt: "xxs",
    borderWidth: {
      base: 0,
      md: 1
    },
    borderColor: themes/* theme.colors.borders.grey */.r.colors.borders.grey,
    boxShadow: themes/* theme.shadows.cards */.r.shadows.cards,
    textAlign: "left",
    display: display,
    whiteSpace: {
      base: 'nowrap',
      md: 'normal'
    },
    children: children
  });
};

/* harmony default export */ var SellOffers_FiltersListBox = (FiltersListBox);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/media-query/dist/index.esm.js
var media_query_dist_index_esm = __webpack_require__(51469);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/accordion/dist/index.esm.js + 1 modules
var accordion_dist_index_esm = __webpack_require__(27190);
;// CONCATENATED MODULE: ./src/components/SellOffers/FiltersListGroup.tsx










var FiltersListGroup = function FiltersListGroup(_ref) {
  var groupLabel = _ref.groupLabel,
      group = _ref.group;
  var dispatch = (0,es/* useDispatch */.I0)();
  var isMobile = (0,media_query_dist_index_esm/* useBreakpointValue */.Sx)({
    base: true,
    md: false
  });

  var toggleFilterHandler = function toggleFilterHandler(value, groupKey) {
    return dispatch((0,actions/* toggleFilter */.cT)(value, groupKey));
  };

  return isMobile ? /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: group.length === 1 ? /*#__PURE__*/(0,jsx_runtime.jsx)(accordion_dist_index_esm/* Accordion */.UQ, {
      fontFamily: "Montserrat-Regular",
      allowToggle: true,
      defaultIndex: [0],
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(SellOffers_FiltersListBox, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(SellOffers_FiltersListItemContent, {
          filter: group[0]
        })
      })
    }) : group.map(function (filter) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)(accordion_dist_index_esm/* Accordion */.UQ, {
        fontFamily: "Montserrat-Regular",
        allowToggle: true,
        defaultIndex: [0],
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(SellOffers_FiltersListBox, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(SellOffers_FiltersListItemContent, {
            filter: filter
          })
        })
      }, filter.label);
    })
  }) : /*#__PURE__*/(0,jsx_runtime.jsx)(SellOffers_FiltersListBox, {
    children: group.length === 1 ? /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
      children: group[0].type === 'switch' ? /*#__PURE__*/(0,jsx_runtime.jsx)(SellOffers_FilterSwitch, {
        groupKey: group[0].key,
        title: group[0].group,
        label: group[0].label,
        onChange: function onChange(_ref2) {
          var target = _ref2.target;
          return toggleFilterHandler(target.value, group[0].key);
        }
      }) : /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Heading */.X6, {
          as: "h4",
          fontFamily: "Montserrat-SemiBold",
          fontSize: themes/* theme.space.m */.r.space.m,
          color: "baseNeutral.700",
          pb: 4,
          children: groupLabel
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(SellOffers_FiltersListItemNoChildren, {
          items: group[0].items,
          groupKey: group[0].key
        })]
      })
    }) : /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Heading */.X6, {
        as: "h4",
        fontFamily: "Montserrat-SemiBold",
        fontSize: themes/* theme.space.m */.r.space.m,
        color: "baseNeutral.700",
        pb: 4,
        children: groupLabel
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(SellOffers_FiltersListItem, {
        items: group
      })]
    })
  });
};

/* harmony default export */ var SellOffers_FiltersListGroup = (FiltersListGroup);
;// CONCATENATED MODULE: ./src/components/SellOffers/FiltersListGroups.tsx






var FiltersListGroups = function FiltersListGroups() {
  var filters = (0,es/* useSelector */.v9)(function (state) {
    return state.sell.filters;
  });
  var filtersGrouped = filters.reduce(function (r, a) {
    r[a.group] = r[a.group] || [];
    r[a.group].push(a);
    return r;
  }, Object.create(null));
  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: Object.keys(filtersGrouped).map(function (filterGroup) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)(SellOffers_FiltersListGroup, {
        groupLabel: filterGroup,
        group: filtersGrouped[filterGroup]
      }, filterGroup);
    })
  });
};

/* harmony default export */ var SellOffers_FiltersListGroups = (FiltersListGroups);
;// CONCATENATED MODULE: ./src/components/SellOffers/FiltersListItem.tsx





var FiltersListItem = function FiltersListItem(_ref) {
  var items = _ref.items;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(accordion_dist_index_esm/* Accordion */.UQ, {
    fontFamily: "Montserrat-Regular",
    allowToggle: true,
    children: Object.keys(items).map(function (idx) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)(SellOffers_FiltersListItemContent, {
        filter: items[idx]
      }, idx);
    })
  });
};

/* harmony default export */ var SellOffers_FiltersListItem = (FiltersListItem);
;// CONCATENATED MODULE: ./src/components/SellOffers/FiltersListItemContent.tsx








var FiltersListItemContent = function FiltersListItemContent(_ref) {
  var filter = _ref.filter;
  var isMobile = (0,media_query_dist_index_esm/* useBreakpointValue */.Sx)({
    base: true,
    md: false
  });
  var dispatch = (0,es/* useDispatch */.I0)();

  var toggleFilterHandler = function toggleFilterHandler(filter, groupKey) {
    return dispatch((0,actions/* toggleFilter */.cT)(filter.value, groupKey));
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(accordion_dist_index_esm/* AccordionItem */.Qd, {
    borderBottomWidth: {
      base: '0 !important'
    },
    borderTopWidth: {
      base: '0',
      md: '1px'
    },
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(accordion_dist_index_esm/* AccordionButton */.KF, {
      paddingInlineStart: "0",
      paddingInlineEnd: "0",
      py: 4,
      _hover: {
        background: 'none'
      },
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
        flex: "1",
        textAlign: "left",
        textTransform: "uppercase",
        fontFamily: "Montserrat-SemiBold",
        children: filter.label
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(accordion_dist_index_esm/* AccordionIcon */.XE, {})]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(accordion_dist_index_esm/* AccordionPanel */.Hk, {
      paddingInlineStart: "0",
      paddingInlineEnd: "0",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(SellOffers_FiltersListItemsWrapper, {
        items: filter.items,
        isMobile: isMobile,
        listedRows: filter.type === 'check',
        children: filter.type === 'icon' ? filter.items.map(function (item) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)(SellOffers_FilterTagImage, {
            isMobile: isMobile,
            item: item,
            groupKey: filter.key,
            onClick: function onClick() {
              return toggleFilterHandler(item, filter.key);
            }
          }, "filters-brands-".concat(item.name, "-").concat(item.value));
        }) : filter.type === 'check' && !isMobile ? filter.items.map(function (item) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)(SellOffers_FilterTagCheckbox, {
            item: item,
            groupKey: filter.key,
            onClick: function onClick() {
              return toggleFilterHandler(item, filter.key);
            }
          }, "filters-".concat(item.name, "-").concat(item.value));
        }) : filter.items.map(function (item) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)(SellOffers_FilterTag, {
            item: item,
            groupKey: filter.key,
            onClick: function onClick() {
              return toggleFilterHandler(item, filter.key);
            }
          }, "filters-".concat(item.name, "-").concat(item.value));
        })
      })
    })]
  });
};

/* harmony default export */ var SellOffers_FiltersListItemContent = (FiltersListItemContent);
;// CONCATENATED MODULE: ./src/components/SellOffers/FiltersListItemNoChildren.tsx









var FiltersListItemNoChildren = function FiltersListItemNoChildren(_ref) {
  var items = _ref.items,
      groupKey = _ref.groupKey;
  var dispatch = (0,es/* useDispatch */.I0)();

  var toggleFilterHandler = function toggleFilterHandler(filter) {
    return dispatch((0,actions/* toggleFilter */.cT)(filter.value, groupKey));
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
      flex: "1",
      textAlign: "left",
      textTransform: "uppercase",
      fontFamily: "Montserrat-SemiBold",
      display: {
        base: 'block',
        md: 'none'
      },
      children: "Tag"
    }), items.map(function (item) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)(SellOffers_FilterTag, {
        item: item,
        groupKey: groupKey,
        onClick: function onClick() {
          return toggleFilterHandler(item);
        }
      }, "filters-ref-".concat(item.name, "-").concat(item.value));
    })]
  });
};

/* harmony default export */ var SellOffers_FiltersListItemNoChildren = (FiltersListItemNoChildren);
;// CONCATENATED MODULE: ./src/components/SellOffers/FiltersListItemsWrapper.tsx




var FiltersListItemsWrapper = function FiltersListItemsWrapper(_ref) {
  var items = _ref.items,
      isMobile = _ref.isMobile,
      listedRows = _ref.listedRows,
      children = _ref.children;

  if (items.some(function (item) {
    return item.icon !== undefined;
  }) && !isMobile) {
    return listedRows ? /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* SimpleGrid */.MI, {
      minChildWidth: "100%",
      spacing: "8px",
      children: children
    }) : /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* SimpleGrid */.MI, {
      minChildWidth: "5.625rem",
      spacing: "8px",
      children: children
    });
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
    overflowX: {
      base: 'scroll',
      md: null
    },
    paddingBottom: {
      base: '0.5rem',
      md: null
    },
    children: children
  });
};

/* harmony default export */ var SellOffers_FiltersListItemsWrapper = (FiltersListItemsWrapper);
// EXTERNAL MODULE: ./src/icons/index.tsx + 28 modules
var icons = __webpack_require__(27120);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/hooks/dist/index.esm.js
var hooks_dist_index_esm = __webpack_require__(39653);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/modal/dist/index.esm.js + 1 modules
var modal_dist_index_esm = __webpack_require__(83292);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/button/dist/index.esm.js
var button_dist_index_esm = __webpack_require__(47741);
;// CONCATENATED MODULE: ./src/components/SellOffers/FiltersModal.tsx











var FiltersModal = function FiltersModal() {
  var _useDisclosure = (0,hooks_dist_index_esm/* useDisclosure */.qY)(),
      isOpen = _useDisclosure.isOpen,
      onOpen = _useDisclosure.onOpen,
      onClose = _useDisclosure.onClose;

  var _useTranslation = (0,useTranslation/* useTranslation */.$)(),
      t = _useTranslation.t;

  var dispatch = (0,es/* useDispatch */.I0)();
  var offers = (0,es/* useSelector */.v9)(function (state) {
    return state.nlt.filteredOffers;
  });
  var selectedFilters = (0,es/* useSelector */.v9)(function (state) {
    return state.sell.selectedFilters;
  });
  var selectedFiltersCount = 0;
  (0,react.useEffect)(function () {
    selectedFiltersCount = selectedFilters.reduce(function (prev, current) {
      return prev + current.items.length;
    }, 0);
  }, []);

  var resetFiltersHandler = function resetFiltersHandler() {
    dispatch((0,actions/* resetAllFilters */._4)());
    onClose();
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(index_esm/* Center */.M5, {
      w: "100%",
      h: "14",
      bg: "primaryGreen.300",
      as: "button",
      onClick: onOpen,
      children: [selectedFiltersCount > 0 ? t('sellActionbarContainer:filters', {
        count: selectedFiltersCount
      }) : t('sellActionbarContainer:showFilters'), /*#__PURE__*/(0,jsx_runtime.jsx)(icons/* FiltersIcon */.sH, {})]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(modal_dist_index_esm/* Modal */.u_, {
      onClose: onClose,
      size: "full",
      isOpen: isOpen,
      scrollBehavior: "inside",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(modal_dist_index_esm/* ModalContent */.hz, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(modal_dist_index_esm/* ModalHeader */.xB, {
          textAlign: "center",
          children: t('sellMobileFiltersModalContainer:doFilter')
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(modal_dist_index_esm/* ModalCloseButton */.ol, {
          mt: "1"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Divider */.iz, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(modal_dist_index_esm/* ModalBody */.fe, {
          p: "0",
          bg: "baseNeutral.200",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(SellOffers_FiltersList, {})
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(modal_dist_index_esm/* ModalFooter */.mz, {
          display: "block",
          padding: "0",
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)(index_esm/* Wrap */.Eq, {
            spacing: "0",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* WrapItem */.Uc, {
              w: "50%",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(button_dist_index_esm/* Button */.zx, {
                w: "100%",
                h: "14",
                borderColor: "primaryGreen.300",
                color: "primaryGreen.900",
                variant: "outline",
                borderRadius: "0",
                onClick: resetFiltersHandler,
                children: t('sellMobileFiltersModalContainer:resetFilters')
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* WrapItem */.Uc, {
              w: "50%",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Center */.M5, {
                w: "100%",
                h: "14",
                bg: "primaryGreen.300",
                as: "button",
                onClick: onClose,
                children: t('nltMobileFiltersModalContainer:showFoundOffer', {
                  value: offers.results
                })
              })
            })]
          })
        })]
      })
    })]
  });
};

/* harmony default export */ var SellOffers_FiltersModal = (FiltersModal);
// EXTERNAL MODULE: ./src/components/common/index.tsx + 14 modules
var common = __webpack_require__(20213);
// EXTERNAL MODULE: ./src/redux/sell-offer/selectors.ts
var selectors = __webpack_require__(43237);
;// CONCATENATED MODULE: ./src/components/SellOffers/FilterTag.tsx






var FilterTag = function FilterTag(_ref) {
  var item = _ref.item,
      groupKey = _ref.groupKey,
      hasCloseButton = _ref.hasCloseButton,
      onClick = _ref.onClick;
  var isHidden = (0,es/* useSelector */.v9)((0,selectors/* filterIsHidden */.ai)(item, groupKey));

  if (isHidden) {
    return null;
  }

  var isSelected = (0,es/* useSelector */.v9)((0,selectors/* filterIsSelected */.$W)(item, groupKey));
  var label = hasCloseButton && item.label && item.label !== '' ? item.label : item.name;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(common/* FilterTag */.dB, {
    isSelected: isSelected,
    onClick: onClick,
    hasCloseButton: hasCloseButton,
    label: label
  });
};

/* harmony default export */ var SellOffers_FilterTag = (FilterTag);
;// CONCATENATED MODULE: ./src/components/SellOffers/FilterTagImage.tsx






var FilterTagImage = function FilterTagImage(_ref) {
  var item = _ref.item,
      groupKey = _ref.groupKey,
      onClick = _ref.onClick,
      isMobile = _ref.isMobile;
  var isHidden = (0,es/* useSelector */.v9)((0,selectors/* filterIsHidden */.ai)(item, groupKey));

  if (isHidden) {
    return null;
  }

  var isSelected = (0,es/* useSelector */.v9)((0,selectors/* filterIsSelected */.$W)(item, groupKey));
  return /*#__PURE__*/(0,jsx_runtime.jsx)(common/* FilterTagImage */.Sz, {
    isSelected: isSelected,
    label: item.name,
    icon: item.icon,
    iconAlt: item.icon_alt || '',
    isMobile: isMobile,
    onClick: onClick
  });
};

/* harmony default export */ var SellOffers_FilterTagImage = (FilterTagImage);
;// CONCATENATED MODULE: ./src/components/SellOffers/FilterSwitch.tsx






var FilterSwitch = function FilterSwitch(_ref) {
  var groupKey = _ref.groupKey,
      title = _ref.title,
      label = _ref.label,
      onChange = _ref.onChange;
  var isSelected = (0,es/* useSelector */.v9)((0,selectors/* filterIsSelected */.$W)({
    label: label,
    name: title,
    value: '1'
  }, groupKey));

  var _useState = (0,react.useState)(isSelected),
      checked = _useState[0],
      setChecked = _useState[1];

  (0,react.useEffect)(function () {
    return setChecked(isSelected);
  }, [isSelected]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(common/* FilterSwitch */.Do, {
    label: label,
    title: title,
    isSelected: checked,
    onChange: onChange
  });
};

/* harmony default export */ var SellOffers_FilterSwitch = (FilterSwitch);
;// CONCATENATED MODULE: ./src/components/SellOffers/FilterTagCheckbox.tsx






var FilterTagCheckbox = function FilterTagCheckbox(_ref) {
  var item = _ref.item,
      groupKey = _ref.groupKey,
      onClick = _ref.onClick;
  var isHidden = (0,es/* useSelector */.v9)((0,selectors/* filterIsHidden */.ai)(item, groupKey));

  if (isHidden) {
    return null;
  }

  var isSelected = (0,es/* useSelector */.v9)((0,selectors/* filterIsSelected */.$W)(item, groupKey));
  return /*#__PURE__*/(0,jsx_runtime.jsx)(common/* FilterTagCheckbox */.TY, {
    isChecked: isSelected,
    onChange: onClick,
    label: item.name
  });
};

/* harmony default export */ var SellOffers_FilterTagCheckbox = (FilterTagCheckbox);
// EXTERNAL MODULE: ./src/components/SellOffers/MobileActionBar.tsx
var MobileActionBar = __webpack_require__(2901);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 1 modules
var styled_components_browser_esm = __webpack_require__(53918);
// EXTERNAL MODULE: ./node_modules/ssr-window/ssr-window.esm.js
var ssr_window_esm = __webpack_require__(85240);
;// CONCATENATED MODULE: ./src/components/SellOffers/OfferDetails.tsx





var TextItem = function TextItem(_ref) {
  var name = _ref.name,
      value = _ref.value;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
    display: "block",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
      color: "baseDark",
      fontFamily: "Montserrat-SemiBold",
      fontSize: "0.875rem",
      letterSpacing: "0.2px",
      lineHeight: "18px",
      display: "inline",
      children: name
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(index_esm/* Text */.xv, {
      color: "baseNeutral.700",
      fontFamily: "Montserrat-Medium",
      fontSize: "1rem",
      letterSpacing: "0.2px",
      lineHeight: "20.8px",
      display: "inline",
      children: [": ", value]
    })]
  });
};

var OfferDetails = function OfferDetails(_ref2) {
  var items = _ref2.items,
      description = _ref2.description;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(index_esm/* Stack */.Kq, {
    textAlign: "left",
    position: "absolute",
    bottom: "0",
    left: "0",
    right: "0",
    display: "block",
    bg: "baseWhite",
    p: "l",
    overflow: "hidden",
    children: [items.map(function (item) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)(TextItem, {
        name: item.name,
        value: item.value
      }, item.name);
    }), description && /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
      color: "baseNeutral.700",
      fontFamily: "Montserrat-Medium",
      fontSize: "0.75rem",
      letterSpacing: "0.4px",
      marginTop: "m",
      children: description
    })]
  });
};

/* harmony default export */ var SellOffers_OfferDetails = (OfferDetails);
;// CONCATENATED MODULE: ./src/components/SellOffers/Offer.tsx












var PriceDiscount = function PriceDiscount(_ref) {
  var name = _ref.name,
      value = _ref.value;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
    mt: "1.3rem",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
      color: "baseNeutral.700",
      fontFamily: "Montserrat-Medium",
      fontSize: "0.75rem",
      letterSpacing: "0.4px",
      display: "inline",
      children: "".concat(name, " ")
    }), value && /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
      color: "baseNeutral.700",
      fontFamily: "Montserrat-Medium",
      fontSize: "1rem",
      letterSpacing: "0.2px",
      display: "inline",
      textDecoration: "line-through",
      children: value
    })]
  });
};

var BoxOverlayOpcaity = (0,styled_components_browser_esm["default"])(index_esm/* Box */.xu).withConfig({
  displayName: "Offer__BoxOverlayOpcaity",
  componentId: "sc-hhj6ta-0"
})(["height:12.5rem;margin-bottom:0.5rem;position:relative;background-color:", ";&:after{content:\" \";z-index:0;display:block;position:absolute;height:100%;top:0;left:0;right:0;background:rgba(70,75,82,", ");}"], function (props) {
  return props.$active ? 'baseNeutral.800' : 'transparent';
}, function (props) {
  return props.$active ? '0.5' : '0';
});

var Offer = function Offer(_ref2) {
  var item = _ref2.item;

  var _useTranslation = (0,useTranslation/* useTranslation */.$)(),
      t = _useTranslation.t;

  var _useState = (0,react.useState)(false),
      active = _useState[0],
      onClick = _useState[1];

  var router = (0,next_router.useRouter)();

  var showDetailsHandler = function showDetailsHandler(e) {
    e.stopPropagation();
    e.nativeEvent.stopImmediatePropagation();
    onClick(!active);
  };

  var getUrlWithReference = function getUrlWithReference(url) {
    var destinationUrl = new URL(url);
    var currentDocumentUrl = new URLSearchParams((0,ssr_window_esm/* getDocument */.Me)().location.search);
    var ref = currentDocumentUrl.get("ref");

    if (ref) {
      var searchParams = destinationUrl.searchParams;
      searchParams.set('ref', ref);
      destinationUrl.search = searchParams.toString();
    }

    return destinationUrl.toString();
  };

  var gotoDetailsHandler = function gotoDetailsHandler() {
    router.push(getUrlWithReference(item.code));
  };

  var title = "".concat(item.brand, " ").concat(item.model);
  var imageAlt = "".concat(t('offerContainer:imageAltSuffix'), " ").concat(item.brand, " ").concat(item.model);
  var priceValue = t('nltOffersComponent:priceValue', {
    value: parseInt("".concat(item.price)).toLocaleString('it-IT')
  });
  var specialPriceValue = item.specialPrice && item.specialPrice > 0 ? t('nltOffersComponent:priceValue', {
    value: parseInt("".concat(item.specialPrice)).toLocaleString('it-IT')
  }) : null;
  var monthlyRateValue = item.monthlyRate && item.monthlyRate > 0 ? t('sellOffersComponent:monthlyRateValue', {
    value: parseInt("".concat(item.monthlyRate)).toLocaleString('it-IT')
  }) : null;
  var offerDetailsItems = [{
    name: t('sellOffersComponent:depositTitle'),
    value: t('sellOffersComponent:depositValue', {
      value: item.deposit.toLocaleString('it-IT')
    })
  }];

  if (monthlyRateValue) {
    offerDetailsItems.unshift({
      name: t('sellOffersComponent:monthlyRateTitle'),
      value: monthlyRateValue
    });
  }

  if (item.tan > 0) {
    offerDetailsItems.push({
      name: t('sellOffersComponent:tanTitle'),
      value: t('sellOffersComponent:tanValue', {
        value: item.tan ? item.tan.toLocaleString('it-IT') : 0
      })
    });
  }

  if (item.taeg > 0) {
    offerDetailsItems.push({
      name: t('sellOffersComponent:taegTitle'),
      value: t('sellOffersComponent:taegValue', {
        value: item.taeg ? item.taeg.toLocaleString('it-IT') : 0
      })
    });
  }

  var limitedOfferBadge = null;

  if (item.expiresAt) {
    var offerTimeStamp = Date.parse(item.expiresAt);
    var nowTimeStamp = new Date().getTime();
    var diffTimeStamp = offerTimeStamp - nowTimeStamp;

    if (diffTimeStamp > 0) {
      limitedOfferBadge = t('nltOffersComponent:limitedOfferBadge', {
        value: Math.floor(diffTimeStamp / (24 * 60 * 60 * 1000))
      });
    }
  }

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
    w: "full",
    title: title,
    borderRadius: 10,
    bg: "baseWhite",
    overflow: "hidden",
    borderColor: active ? 'primaryGreen.600' : '#d9dde1',
    borderWidth: "1px",
    boxShadow: "0 2px 8px 0px rgba(65, 164, 118, 0.12)",
    _hover: {
      cursor: 'pointer',
      textDecoration: 'none',
      boxShadow: '0 4px 12px 0px rgba(65, 164, 118, 0.22)'
    },
    onClick: gotoDetailsHandler,
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(BoxOverlayOpcaity, {
      $active: active,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
        src: item.image,
        alt: imageAlt,
        layout: "fill",
        objectFit: "contain",
        loading: "lazy"
      }), limitedOfferBadge && /*#__PURE__*/(0,jsx_runtime.jsx)(uikit/* LimitedOfferBadge */.Ld, {
        position: "absolute",
        top: "1rem",
        left: "1rem",
        children: limitedOfferBadge
      }), item.mainTag && /*#__PURE__*/(0,jsx_runtime.jsx)(uikit/* InfoBadge */.Uq, {
        position: "absolute",
        bottom: ".625rem",
        left: "1rem",
        children: item.mainTag
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Divider */.iz, {
        color: "red",
        position: "absolute",
        bottom: "0rem"
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(index_esm/* Stack */.Kq, {
      textAlign: "left",
      pos: "relative",
      height: "7rem",
      children: [!active && /*#__PURE__*/(0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
        px: "l",
        color: "baseDark",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("a", {
          href: getUrlWithReference(item.code),
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(uikit/* OfferCardTitle */.PP, {
            title: title,
            subtitle: item.version
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
          children: [monthlyRateValue ? /*#__PURE__*/(0,jsx_runtime.jsx)(uikit/* PriceBox */.bz, {
            value: monthlyRateValue,
            description: t('sellOffersComponent:priceDescriptionMonthly'),
            textAlign: "right",
            position: "absolute",
            top: "3.8rem",
            right: "1.5rem"
          }) : /*#__PURE__*/(0,jsx_runtime.jsx)(uikit/* PriceBox */.bz, {
            value: specialPriceValue || priceValue,
            description: t('sellOffersComponent:priceDescription'),
            textAlign: "right",
            position: "absolute",
            top: "3.8rem",
            right: "1.5rem"
          }), specialPriceValue && /*#__PURE__*/(0,jsx_runtime.jsx)(PriceDiscount, {
            name: t('sellOffersComponent:priceStartFrom'),
            value: specialPriceValue ? priceValue : null
          })]
        })]
      }), active && /*#__PURE__*/(0,jsx_runtime.jsx)(SellOffers_OfferDetails, {
        items: offerDetailsItems,
        description: item.description
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
      color: "baseDark",
      fontFamily: "Montserrat-Medium",
      fontSize: "1rem",
      pb: "l",
      letterSpacing: "0.4px",
      onClick: showDetailsHandler,
      cursor: "pointer",
      title: active ? t('sellOffersComponent:hideDetails') : t('sellOffersComponent:showDetails'),
      children: active ? "".concat(t('sellOffersComponent:hideDetails'), " - ") : "".concat(t('sellOffersComponent:showDetails'), " +")
    })]
  });
};

/* harmony default export */ var SellOffers_Offer = (Offer);
// EXTERNAL MODULE: ./src/redux/sell-offer/index.ts + 1 modules
var sell_offer = __webpack_require__(7232);
;// CONCATENATED MODULE: ./src/components/SellOffers/SortsModal.tsx










var SortsModal = function SortsModal() {
  var dispatch = (0,es/* useDispatch */.I0)();

  var _useDisclosure = (0,hooks_dist_index_esm/* useDisclosure */.qY)(),
      isOpen = _useDisclosure.isOpen,
      onOpen = _useDisclosure.onOpen,
      onClose = _useDisclosure.onClose;

  var _useTranslation = (0,useTranslation/* useTranslation */.$)(),
      t = _useTranslation.t;

  var orders = (0,es/* useSelector */.v9)(function (state) {
    return state.sell.orders;
  });

  var changeOrderHandler = function changeOrderHandler(value) {
    return dispatch((0,sell_offer/* toggleOrder */.YQ)(value));
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(index_esm/* Center */.M5, {
      w: "100%",
      h: "14",
      as: "button",
      onClick: onOpen,
      children: [t('sellActionbarContainer:sortBy'), " ", /*#__PURE__*/(0,jsx_runtime.jsx)(dist_index_esm/* ChevronDownIcon */.v4, {})]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(modal_dist_index_esm/* Drawer */.dy, {
      placement: "bottom",
      onClose: onClose,
      isOpen: isOpen,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(modal_dist_index_esm/* DrawerOverlay */.P1, {}), /*#__PURE__*/(0,jsx_runtime.jsxs)(modal_dist_index_esm/* DrawerContent */.sc, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(modal_dist_index_esm/* DrawerCloseButton */.cC, {
          mt: "1"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(modal_dist_index_esm/* DrawerHeader */.OX, {
          borderBottomWidth: "1px",
          children: t('sellMobileFiltersModalContainer:doSort')
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(modal_dist_index_esm/* DrawerBody */.Ng, {
          children: orders.map(function (sort) {
            return /*#__PURE__*/(0,jsx_runtime.jsx)(button_dist_index_esm/* Button */.zx, {
              borderRadius: "0",
              w: "100%",
              bg: "baseWhite",
              mt: "xxs",
              onClick: function onClick() {
                return changeOrderHandler(sort.value);
              },
              fontWeight: "normal",
              children: sort.label || sort.name
            }, sort.value);
          })
        })]
      })]
    })]
  });
};

/* harmony default export */ var SellOffers_SortsModal = (SortsModal);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
;// CONCATENATED MODULE: ./src/components/SellOffers/SuggestedFilters.tsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }












var SuggestedFilters = function SuggestedFilters(_ref) {
  var colSpan = _ref.colSpan;

  var _useTranslation = (0,useTranslation/* useTranslation */.$)(),
      t = _useTranslation.t;

  var dispatch = (0,es/* useDispatch */.I0)();
  var allFilters = (0,es/* useSelector */.v9)(selectors/* filters */.u8);
  var selectedFilters = (0,es/* useSelector */.v9)(selectors/* selectedFilters */.L$);
  var suggestedFilters = (0,es/* useSelector */.v9)(function (state) {
    return state.sell.suggestedFilters;
  });

  var toggleFilterHandler = function toggleFilterHandler(filter, groupKey) {
    return dispatch((0,actions/* toggleFilter */.cT)(filter.value, groupKey));
  };

  var resetFiltersHandler = function resetFiltersHandler() {
    return dispatch((0,actions/* resetAllFilters */._4)());
  };

  var _useState = (0,react.useState)(false),
      isMounted = _useState[0],
      setMount = _useState[1];

  (0,react.useEffect)(function () {
    setMount(true);
  }, []);

  if (!isMounted) {
    return null;
  }

  var selectedFiltersExceptSuggested = [];
  selectedFilters.forEach(function (selectedFilter) {
    suggestedFilters.forEach(function (suggestedFilter) {
      var items = [];
      var selectedFiltersExceptSuggestedItem = {
        key: selectedFilter.key,
        items: items
      };

      if (selectedFilter.key === suggestedFilter.key) {
        selectedFilter.items.forEach(function (selectedItem) {
          if (!suggestedFilter.items.length || !suggestedFilter.items.some(function (suggestedItem) {
            return suggestedItem.name === selectedItem.name;
          })) {
            var selectedCompleteItem = (0,selectors/* getFilterByGroupAndValue */.jN)(allFilters, selectedFilter.key, selectedItem.value);

            if (selectedCompleteItem) {
              selectedFiltersExceptSuggestedItem.items.push(selectedCompleteItem);
            }
          }
        });
      } else {
        selectedFiltersExceptSuggestedItem.items = selectedFilter.items.map(function (filterItem) {
          var validatedFilterItem = (0,selectors/* getFilterByGroupAndValue */.jN)(allFilters, selectedFilter.key, filterItem.value);

          if (validatedFilterItem) {
            return _objectSpread({}, validatedFilterItem);
          }

          return null;
        }).filter(function (filterItem) {
          return filterItem !== null;
        });
      }

      selectedFiltersExceptSuggested.push(selectedFiltersExceptSuggestedItem);
    });
  });
  var displayResetFilters = selectedFilters.flatMap(function (selectedFilter) {
    return selectedFilter.items;
  }).length > 0;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(index_esm/* GridItem */.P4, {
    display: {
      base: 'none',
      sm: 'block'
    },
    colSpan: colSpan,
    mt: "-2",
    textAlign: "left",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
      fontFamily: "Montserrat-SemiBold",
      fontWeight: "bold",
      fontSize: themes/* theme.space.s */.r.space.s,
      color: "baseNeutral.700",
      children: t('offersListContainer:suggestedFilters')
    }), suggestedFilters.map(function (filterGroup) {
      return filterGroup.items.map(function (item) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)(SellOffers_FilterTag, {
          item: item,
          groupKey: filterGroup.key,
          onClick: function onClick() {
            return toggleFilterHandler(item, filterGroup.key);
          }
        }, "suggested-".concat(item.name, "-").concat(item.value));
      });
    }), selectedFiltersExceptSuggested.map(function (filterGroup) {
      return filterGroup.items.map(function (item) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)(SellOffers_FilterTag, {
          item: item,
          groupKey: filterGroup.key,
          onClick: function onClick() {
            return toggleFilterHandler(item, filterGroup.key);
          },
          hasCloseButton: true
        }, "filtered-".concat(item.name, "-").concat(item.value));
      });
    }), displayResetFilters && /*#__PURE__*/(0,jsx_runtime.jsx)(button_dist_index_esm/* Button */.zx, {
      onClick: resetFiltersHandler,
      color: "baseDark",
      variant: "link",
      fontFamily: "Montserrat-Medium",
      fontWeight: "normal",
      ml: "m",
      children: t('offersListContainer:resetFilters')
    })]
  }, "filtri-suggeriti");
};

/* harmony default export */ var SellOffers_SuggestedFilters = (SuggestedFilters);
;// CONCATENATED MODULE: ./src/components/SellOffers/index.tsx




















/***/ })

}]);